export default __webpack_public_path__ + "static/media/eye-show.5d8e0b52.svg";